export function stringToBytes(s: string): Uint8Array;
export function stringToBytes(s: undefined): undefined;
export function stringToBytes(s: string | undefined): Uint8Array | undefined;

/**
 * Convert the provided string to bytes. If the string is undefined, undefined will be returned.
 *
 * @internal
 */
export function stringToBytes(s: string | undefined): Uint8Array | undefined {
  if (s === undefined) {
    return undefined;
  }

  if (!textEncoder) {
    textEncoder = new TextEncoder();
  }

  return textEncoder.encode(s);
}

/** Defer instantiating this till used, as TextEncoder may not exist at time of module import. */
let textEncoder: TextEncoder | undefined;

// Generate UUID - 12 bytes of entropy per Android implementation, base64 encoded
// https://docs.google.com/document/d/1mrtld8oOxF3yCHwF8ZXqHrzfIJDDIq4d0S-taDRV-kQ/view
const sessionIdLengthBytes = 12;
/** Generates a random base64 UUID. */
export function generateBase64UUId(): string {
  return btoa(
    String.fromCharCode(...self.crypto.getRandomValues(new Uint8Array(sessionIdLengthBytes)))
  );
}
